import { InjectionToken } from "@angular/core";
import {SopiHankoOptions} from "./model";

export const HANKO_URL = new InjectionToken<string>(
  'sopi.hanko.url'
);

export const HANKO_AUTH_API_URL = new InjectionToken<string>(
  'sopi.hanko.auth.api.url'
);

export const HANKO_OPTIONS = new InjectionToken<SopiHankoOptions>(
  'sopi.hanko.options'
);
